import React from 'react';
import { useResponsive } from '../../../hooks/useResponsive';
import IncomePage from './IncomePage';
import { IncomePageMobile } from './IncomePageMobile';

const IncomePageWrapper: React.FC = () => {
  const { isMobile } = useResponsive();

  return isMobile ? <IncomePageMobile /> : <IncomePage />;
};

export default IncomePageWrapper; 